import React from 'react';
import {ImageUploader} from '../uploaders';
import LayerData from './layer-data';
import './stage-editor.css';

/** @class ImageLayerData
 * A component for editing image layer-specific properties.
 */
export default class ImageLayerData extends LayerData {
  /** @function render
    * Renders the component.
    */
  render(){
    return (
      <div className="dialog-content">
        <h3 className="header">Image Layer</h3>
        <div className="input-group">
          <label htmlFor="name">Name</label><br/>
          <input type="text" name="name"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="x">X position</label><br/>
          <input type="number" name="x"
            value={this.state.x}
            onChange={this.handleIntChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="y">Y position</label><br/>
          <input type="number" name="y"
            value={this.state.y}
            onChange={this.handleIntChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="width">Width</label><br/>
          <input type="number" name="width"
            value={this.state.width}
            onChange={this.handleIntChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="height">Height</label><br/>
          <input type="number" name="height"
            value={this.state.height}
            onChange={this.handleIntChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <ImageUploader
            name="Image"
            value={this.state.image}
            dataURL={this.props.dataURL}
            onUpload={(url) => this.handleImageUpload("image", url)}
            />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/stage-editor/image-layer-data.js